import { createWebHistory, createRouter } from 'vue-router'
import MainPage from '../components/MainPage.vue';
import ManifestCourier from '../components/ManifestCourier.vue';
import LoginPage from '../components/LoginPage.vue';

const routes = [
    {
        path : '/dashboard',
        name : 'dashboard',
        component: MainPage,
        meta :{
            requiresAuth: true,
            title : "cablak"
        }
    },
    {
        path : '/manifest-courier',
        name : 'manifest_courier',
        component: ManifestCourier,
        meta :{
            requiresAuth: true
        }
    },
    {
        path : '/',
        name : 'login',
        component: LoginPage
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')
    if(to.matched.some(record => record.meta.requiresAuth)){
        if(!token){
            next('/')
        }else{
            next()
        }
    }else{
        if(token){
            next('/dashboard')
        }else{
            next()
        }
    }
})


export default router